define('plugin/push-notifications/controller/PushNotificationsController',['require','lib/controller/BaseController','plugin/push-notifications/model/PushMessageModel','plugin/push-notifications/view/PushMessageView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var PushMessageModel = require('plugin/push-notifications/model/PushMessageModel');
    var PushMessageView = require('plugin/push-notifications/view/PushMessageView');

    /**
     * Push notifications Controller
     *
     * @class PushNotificationsController
     */
    return BaseController.extend({

        _collection: null,

        initialize: function () {
            BaseController.prototype.initialize.call(this);
        },

        viewPush: function (id, hash) {
            var model = new PushMessageModel({
                id: id,
                hash: hash,
                type: 'message',
            });
            model.fetch({reset: true});

            var detailsView = new PushMessageView({
                model: model,
            });
            this.getMainLayout().getContentRegion().show(detailsView);
        },

        viewCampaign: function(id, hash) {
            var model = new PushMessageModel({
                id: id,
                hash: hash,
                type: 'campaign',
            });
            model.fetch({reset: true});

            var detailsView = new PushMessageView({
                model: model,
            });
            this.getMainLayout().getContentRegion().show(detailsView);
        }

    });

});
